import { atom } from "recoil";

export const userTypeState = atom({
  key: "userTypeState",
  default: {},
});
